export const ApiEventNames = Object.freeze({
    ApiNotFound: 'api-not-found-error', // api不存在错误
    LocalApiError: 'local-api-error', // api未处理的本地错误
    Unauthorized: 'unauthorized-error',
    Forbidden: 'forbidden-error',
    ApiError: 'error',
});
